export default "__VITE_ASSET__BK8P$wy2__"